// extracted by mini-css-extract-plugin
module.exports = {"ssMmainD":"SuccessStoriesF4_ssMmainD__3dtG6"};